import { Dispatch, SetStateAction } from "react";
import { clinicId } from "../../../constants";

export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  templateId: number;
  cpt_id: number;
  clinicId: number;
  template_status: number;
  loinc_name: string | null;
  loinc_id: number | null;
  cpt_code: string;
  cpt_name: string;
  template_name: string;
  // loinc_name: string | null;
};

export type SaveResponseType = {};

export type MasterFormData = {
  templateName: string;
  status: number;
  cpt: CptListType | null;
  loinc: LoincListType | null;
};

export type CptListType = {
  cptRate?: number;
  cptCode: string;
  cptDes?: string;
  cptName: string;
  cptId: number;
  templateName?: string;
  cptGroupId?: number;
  isPackage?: boolean;
};

export type LoincListType = {
  loincId: number;
  loincCode?: string;
  loincName: string;
  loincValue?: string;
  loincStatus?: number;
};

export type TemplateFieldType = {
  fieldName: string;
  fieldRange: string;
  clinicId?: number;
  loincName?: string;
  cptCode?: string;
  loincId?: number;
  templateStatus?: number;
  cptName?: string;
  cptId?: number;
  fieldUnit?: string;
  templateName?: string;
  templateId: number;
  loincCode: string | null;
};

export type MasterDataType = {
  loincId: number | null;
  cptId: number;
  templateName: string;
  status: number;
  createdByDate: string;
  templateId: number;
  localCode: string;
  cptCode: string;
  fields: TemplateFieldType[];
};

export type TemplateListContextType = {
  fullList: TemplateFieldType[];
  setFullList: Dispatch<SetStateAction<TemplateFieldType[]>>;
  edit: TemplateFieldType;
  setEdit: Dispatch<SetStateAction<TemplateFieldType>>;
};

export type LabListType = {
  id: number;
  code: string;
  ltemplateName: string;
  ltemplateUnit: string;
  ltemplateRange: string | number;
};

export const initialField: TemplateFieldType = {
  fieldName: "",
  fieldRange: "",
  clinicId,
  loincName: "",
  cptCode: "",
  loincId: 0,
  templateStatus: 0,
  cptName: "",
  cptId: 0,
  fieldUnit: "",
  templateName: "",
  templateId: 0,
  loincCode: null,
};

export const initialFormData: MasterFormData = {
  cpt: null,
  loinc: null,
  status: 1,
  templateName: "",
};
